import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { ThemeModeProvider } from "./components/theme";
// import reportWebVitals from "./reportWebVitals";
import "./index.css";

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
